import { useEffect, useState } from 'react';
import { WatchlistApi } from '@apply/api';
import { applicationInsights } from '../../ApplicationInsights';
import { handleAdminError } from '../../common/SharedFunctions';
import DataGrid, { Column } from 'devextreme-react/data-grid';
import LoadPanel from 'devextreme-react/load-panel';
import { formatDateMonthDayYear, formatCurrency } from '@apply/ui';

const LiquidityHistoryTable = ({ loanId }) => {
    const [data, set_data] = useState([]);
    const [loadingMessage, set_loadingMessage] = useState('');
    const watchlistApi = new WatchlistApi.WatchlistApi(applicationInsights);

    const formatDate = (dt) => {
        if (!dt) {
            return null;
        }
        return formatDateMonthDayYear(dt);
    };

    const onDateRender = (e) => {
        return formatDate(e.value);
    };

    const onCurrencyRender = (e) => {
        return formatCurrency(e.value, 0);
    };

    const loadHistoryAsync = async (loanId) => {
        try {
            set_loadingMessage('Retrieving history...');
            const response = await watchlistApi.getLiquidityHistory(loanId);
            if (response.statusCode !== 200) {
                throw new Error('Failed to retrieve data!');
            }
            const records = response.result;
            set_data(records);
        } catch (ex) {
            handleAdminError(ex, 'Failed to retrieve records! Please refresh the page and try again.');
        } finally {
            set_loadingMessage('');
        }
    };

    useEffect(() => {
        if (!loanId) {
            return;
        }

        loadHistoryAsync(loanId);
    }, [loanId]);

    if (!loanId) {
        return null;
    }

    return (
        <>
            <DataGrid
                keyExpr={'id'}
                dataSource={data}
                rowAlternationEnabled={true}
                showBorders={true}
                showColumnHeaders={true}
                showRowLines={true}
                wordWrapEnabled={true}
                noDataText={'No liquidity history found for this loan'}
            >
                <Column
                    dataField='createdAt'
                    caption='Date'
                    width={100}
                    cellRender={onDateRender}
                    sortIndex={0}
                    sortOrder={'desc'}
                />
                <Column
                    dataField='liquidity'
                    caption='Liquidity'
                    width={100}
                    alignment='left'
                    cellRender={onCurrencyRender}
                />
                <Column
                    dataField='userName'
                    caption='Changed By'
                    alignment='left'
                />
            </DataGrid>
            <LoadPanel
                hideOnOutsideClick={false}
                visible={!!loadingMessage}
                message={loadingMessage}
            />
        </>
    );
};

export default LiquidityHistoryTable;
